import Modal from '@/components/base/Modal';
import Button from '@/components/base/Button';
import type { Biller } from '@/types/portal';

interface BillFavouritesModalProps {
  open: boolean;
  onClose: () => void;
  billers: Biller[];
  onToggle: (id: string) => void;
}

/** Pin or unpin billers from the favourites row on the Pay a Bill screen. */
export default function BillFavouritesModal({
  open,
  onClose,
  billers,
  onToggle,
}: BillFavouritesModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      icon="ri-star-line"
      title="Favourite billers"
      subtitle="Pin the billers you pay most often for one-tap access."
      footer={
        <Button icon="ri-check-line" onClick={onClose}>
          Done
        </Button>
      }
    >
      <ul className="divide-y divide-background-100">
        {billers.map((biller) => {
          const isFavourite = biller.favourite;
          return (
            <li key={biller.id} className="flex items-center gap-3 py-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-100 text-sm font-semibold text-accent-800">
                {biller.mark}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-foreground-950">{biller.name}</p>
                <p className="truncate text-xs text-foreground-500">
                  {biller.category} · Paybill {biller.paybill}
                </p>
              </div>
              <button
                type="button"
                onClick={() => onToggle(biller.id)}
                aria-pressed={isFavourite}
                aria-label={isFavourite ? `Remove ${biller.name} from favourites` : `Add ${biller.name} to favourites`}
                className={`flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full text-base transition-colors ${
                  isFavourite
                    ? 'text-accent-500 hover:bg-accent-50'
                    : 'text-foreground-300 hover:bg-background-200 hover:text-foreground-500'
                }`}
              >
                <i className={isFavourite ? 'ri-star-fill' : 'ri-star-line'} />
              </button>
            </li>
          );
        })}
      </ul>
    </Modal>
  );
}